export default __webpack_public_path__ + "static/media/living-room5.79585949.jpg";